import React from 'react';

export default function template() {
  return <div ref={this.renderCaptcha.bind(this)} className={'captcha'} />;
}
